export default {
    Dot: '.',
    Comma: ',',
}